import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../mock';

export default function Services() {
  return (
    <section className="py-24 bg-fx-slate">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Our Services</p>
          <h2 className="font-display text-4xl lg:text-5xl text-fx-navy font-bold mt-3">What we offer you</h2>
          <div className="fx-section-divider mx-auto mt-5" />
          <p className="mt-5 text-slate-600">Three core financing solutions designed around your business stage, cashflow and growth goals.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-7 mt-14">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <Link key={s.id} to={s.href} className="group relative rounded-lg overflow-hidden bg-white fx-lift border border-slate-100">
                <div className="relative h-56 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms] ease-out" />
                  <div className="absolute inset-0 bg-gradient-to-t from-fx-navy/85 via-fx-navy/20 to-transparent" />
                  <div className="absolute top-5 left-5 w-11 h-11 rounded-md bg-white/95 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-fx-navy" />
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="font-display text-2xl text-fx-navy font-bold">{s.title}</h3>
                  <p className="text-slate-600 mt-2 text-sm leading-relaxed">{s.description}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-fx-navy font-semibold text-sm group-hover:text-fx-gold transition-colors">
                    Learn more <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
